import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { displayAlertifyError } from "../../util/functions";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      margin: 0,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
  })
);

const styles = (theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function Item() {
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [items, setItems] = useState([]);
  const [taxes, setTaxes] = useState([]);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [note, setNote] = useState("");
  const [taxName, setTaxName] = useState("");
  const [percentage, setPercentage] = useState("");
  const [count, setCount] = useState(0);
  const [saveBtn, setSaveBtn] = useState(true);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [search, setSearch] = useState("");
  const [foundItems, setFoundItems] = useState(items);
  const [noResult, setNoResult] = useState(false);

  const [taxInfo, setTaxInfo] = useState([]);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  // function handleChange(event) {
  //     let item = event.target.value;
  //     const checkedArr = [];
  //     // checkedArr.push(item);
  //     const checkeds = document.getElementsByName('checkbox');
  //     for (let i = 0; i < checkeds.length; i++) {
  //         if (checkeds[i].checked) {
  //         checkedArr.push(checkeds[i].value);
  //         }
  //     }
  //     console.log(item);

  //     setSelectedCheckboxes(checkedArr);
  // }

  // const toggleHandler = (item) => () => {
  // let tempTaxInfo = taxInfo;
  // //here we look if your checked item is allready in your array. if so, remove with filter.
  // if (tempTaxInfo.some((taxes) => taxes.id === item.id)) {
  //     tempTaxInfo = tempTaxInfo.filter((taxes) => taxes.id !== item.id);
  // } else {
  //     tempTaxInfo.push(item);
  // }
  // setTaxInfo(tempTaxInfo);
  // };

  const filter = (event) => {
    setNoResult(true);
    const keyword = event;

    if (keyword !== "") {
      const results = items.filter((item) => {
        return item.name.toLowerCase().includes(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      setFoundItems(results);
    } else {
      setFoundItems(items);
      // If the text field is empty, show all users
    }

    setSearch(keyword);
  };

  function allFilter() {
    setFoundItems(items);
  }

  function handleClickOpen() {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  useEffect(async () => {
    setLoading(true);
    await axios
      .get(host + "get-items/" + userid, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setItems(response.data.items);
        setFoundItems(response.data.items);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [count]);

  function getData(id) {
    axios
      .get(host + "item-detail/" + id, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setSaveBtn(false);
        setUpdateBtn(true);
        setId(response.data.item.id);
        setName(response.data.item.name);
        setPrice(response.data.item.price);
        if (response.data.note === null) {
          setNote("");
        } else {
          setNote(response.data.item.note);
        }
      })
      .catch(function (error) {
        displayAlertifyError({ error: error });
      });
  }

  function deleteItem(id) {
    axios
      .post(
        host + "item-delete",
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch(function (error) {
        displayAlertifyError({ error: error });
      });
  }

  function newItem() {
    console.log(selectedCheckboxes);
    setSaveBtn(true);
    setUpdateBtn(false);
    setTaxInfo([]);
    setCount(count + 1);
    setName("");
    setPrice("");
    setNote("");
  }

  function createItem() {
    let nameVal = $("#name").val();
    setName(nameVal);
    let PriceVal = $("#price").val();
    setPrice(PriceVal);
    let noteVal = $("#note").val();
    setNote(noteVal);
    let params = {
      userid: userid,
      name: name,
      price: price,
      note: note,
      taxes: taxInfo,
    };

    if (nameVal === "" || nameVal === undefined) {
      displayAlertifyError({ error: "Please enter name" });
      return false;
    }
    if (PriceVal === "" || PriceVal === undefined) {
      displayAlertifyError({ error: "Please enter price" });
      return false;
    }

    return axios
      .post(host + "create-item", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
        setTaxInfo([]);
        setName("");
        setPrice("");
        setNote("");
      })
      .catch((response) => {
        console.log(response);
      });
  }

  // function createTax () {
  //     let taxNameVal = $("#tax_name").val();
  //     setTaxName(taxNameVal);
  //     let percentageVal = $("#percentage").val();
  //     setPercentage(percentageVal);
  //     let params = {'userid': userid,'name': taxName, 'percentage': percentage};

  //     if(taxNameVal === "" || taxNameVal === undefined){
  //         displayAlertifyError({error: 'Please enter tax name'});
  //         return false;
  //     }
  //     if(!Number(percentageVal)) {
  //         displayAlertifyError({error: 'Please enter number'});
  //         return false;
  //     }
  //     if(percentageVal === "" || percentageVal === undefined){
  //         displayAlertifyError({error: 'Please enter percentage'});
  //         return false;
  //     }

  //     return axios.post(host + "create-tax", params,{
  //         'headers': {
  //           'Content-Type': 'application/json',
  //           'Accept': 'application/json',
  //           Authorization: "Bearer " + token,
  //         }
  //       })
  //     .then(response => {
  //         alertify.success(response.data.message);
  //         setOpen2(false);
  //         setCount(count+1);
  //         setTaxName("");
  //         setPercentage("");

  //     }).catch(response=>{
  //         console.log(response);
  //     })

  // }

  function updateItem() {
    let nameVal = $("#name").val();
    setName(nameVal);
    let PriceVal = $("#price").val();
    setPrice(PriceVal);
    let noteVal = $("#note").val();
    setNote(noteVal);
    let params = { id: id, name: name, price: price, note: note };

    if (nameVal === "" || nameVal === undefined) {
      displayAlertifyError({ error: "Please enter name" });
      return false;
    }
    if (PriceVal === "" || PriceVal === undefined) {
      displayAlertifyError({ error: "Please enter price" });
      return false;
    }

    return axios
      .post(host + "update-item", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  function exportItem() {
    axios
      .get(host + "export-item/" + userid, {
        headers: {
          "Content-Type": "application/excel",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "items.csv"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  function sampleItem() {
    axios
      .get(host + "download-sample-item/", {
        headers: {
          "Content-Type": "application/excel",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "sample-items.csv"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  function importItem() {
    const fd = new FormData();
    if (selectedFile === "" || selectedFile === undefined) {
      displayAlertifyError({ error: "Please select excel file first." });
      return false;
    } else {
      fd.append("file", selectedFile, selectedFile.name);
    }
    return axios
      .post(host + "import-item/" + userid, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setOpen(false);
        alertify.success(response.data.message);
        setCount(count + 1);
      })
      .catch((response) => {
        console.log(response);
      });
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <Dialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                  >
                    <DialogTitle
                      id="customized-dialog-title"
                      onClose={handleClose}
                    >
                      Import Items in Bulk
                    </DialogTitle>
                    <DialogContent dividers>
                      <Link onClick={() => sampleItem()}>
                        <h3>1. Download Sample File</h3>
                      </Link>
                      <h3>2. Fill out the information you want to import.</h3>
                      <form enctype="multipart/form-data">
                        <input
                          type="file"
                          name="file"
                          onChange={changeHandler}
                        />
                      </form>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button autoFocus onClick={importItem} color="primary">
                        Import Data
                      </Button> */}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={importItem}
                      >
                        Import Data
                      </button>
                    </DialogActions>
                  </Dialog>

                  <div className="col-12 col-lg-4">
                    <div className="row pl-3">
                      <FormControl className="col-12 col-lg-6">
                        <InputLabel id="demo-simple-select-label">
                          Import/Export
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="import-export"
                          name="import-export"
                        >
                          <MenuItem
                            value={1}
                            onClick={() => {
                              handleClickOpen();
                            }}
                          >
                            Import
                          </MenuItem>
                          <MenuItem
                            value={2}
                            onClick={() => {
                              exportItem();
                            }}
                          >
                            Export
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <div className="col-12 col-lg-6 text-md-right pl-0 pl-md-3 pt-3 pt-md-0">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => newItem()}
                        >
                          New Item
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <SearchBar
                            placeholder="Search"
                            value={search}
                            onChange={filter}
                            onCancelSearch={allFilter}
                          />
                          <div
                            className="card-body mt-2"
                            style={{
                              maxHeight: 478,
                              minHeight: 450,
                              overflow: "auto",
                            }}
                          >
                            <div className={classes.root}>
                              {!loading ? (
                                foundItems && foundItems.length > 0 ? (
                                  foundItems.map((item) => (
                                    <List
                                      component="nav"
                                      aria-label="secondary mailbox folders"
                                      key={item.id}
                                    >
                                      <ListItem
                                        button
                                        key={item.id}
                                        id={item.id}
                                        onClick={() => getData(item.id)}
                                      >
                                        <ListItemText
                                          style={{ color: "#FC3538" }}
                                          primary={item.name}
                                        />
                                      </ListItem>
                                      <ListItemSecondaryAction>
                                        <IconButton
                                          edge="end"
                                          aria-label="delete"
                                          onClick={() => deleteItem(item.id)}
                                        >
                                          <DeleteIcon color="error" />
                                        </IconButton>
                                      </ListItemSecondaryAction>
                                      <Divider />
                                    </List>
                                  ))
                                ) : noResult ? (
                                  <h4>No results found!</h4>
                                ) : (
                                  <h1></h1>
                                )
                              ) : (
                                <DivLoader>
                                  <Loader
                                    type="Oval"
                                    color="#FC3538"
                                    height={50}
                                    width={50}
                                  />
                                </DivLoader>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-12 d-flex justify-content-md-end">
                        {updateBtn ? (
                          <button
                            type="button"
                            className="btn btn-primary pull-right mr-2"
                            onClick={() => {
                              updateItem();
                            }}
                          >
                            Update
                          </button>
                        ) : null}
                        {saveBtn ? (
                          <button
                            type="button"
                            className="btn btn-primary pull-right mr-2"
                            onClick={() => {
                              createItem();
                            }}
                          >
                            Save
                          </button>
                        ) : null}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body">
                            <form id="create_client">
                              <div
                                className="row"
                                style={{
                                  maxHeight: 490,
                                  minHeight: 490,
                                  overflow: "auto",
                                }}
                              >
                                <Box
                                  fontSize={20}
                                  fontWeight="bold"
                                  ml={2}
                                  mb={0}
                                >
                                  Basic Info
                                </Box>
                                <div className="col-12">
                                  <div className="form-group mb-0">
                                    <label className="mdc-floating-label--shake">
                                      Item Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="name"
                                      name="name"
                                      required="required"
                                      autoFocus
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group mb-0">
                                    <label className="mdc-floating-label--shake">
                                      Rate
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="price"
                                      name="price"
                                      required="required"
                                      value={price}
                                      onChange={(e) => setPrice(e.target.value)}
                                    />
                                  </div>
                                </div>

                                <Box
                                  fontSize={20}
                                  fontWeight="bold"
                                  mt={2}
                                  ml={2}
                                  mb={0}
                                >
                                  Description
                                </Box>
                                <div className="col-12">
                                  <div className="form-group mb-0">
                                    <label className="mdc-floating-label--shake">
                                      Note
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      id="note"
                                      name="note"
                                      required
                                      value={note}
                                      onChange={(e) => setNote(e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default Item;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
